/**
 * Created by mac on 10/21/22
 */

const ExpeditionPage = function (locationId) {
    const locationConfig = cleverapps.meta.getLocationMeta(locationId).locationConfig;

    Object.assign(this, locationConfig);

    this.level = this.level || 0;

    this.attentionEvent = cleverapps.dataLoader.load(DataLoader.TYPES.TRAVEL_BOOK_ATTENTION + this.id) || false;

    this.livesWasFull = this.isLivesFull();

    if (this.livesWasFull) {
        this.planEvent(ExpeditionPage.EVENT_ENERGY, Date.now());
        this.setAttentionEvent(ExpeditionPage.EVENT_ENERGY);
    }
};

ExpeditionPage.TYPE_SKIP = 0;
ExpeditionPage.TYPE_ACTIVE = 1;
ExpeditionPage.TYPE_UPCOMING = 2;

ExpeditionPage.prototype.checkFullLives = function () {
    const isFull = this.isLivesFull();

    if (this.livesWasFull !== isFull) {
        if (!this.livesWasFull && isFull) {
            this.planEvent(ExpeditionPage.EVENT_ENERGY, Date.now());
            this.setAttentionEvent(ExpeditionPage.EVENT_ENERGY);
        }

        this.livesWasFull = isFull;
    }
};

ExpeditionPage.prototype.isLivesFull = function () {
    if (this.usesEnergy) {
        const lives = LivesHelper.GetTmpInstance(this.id);
        return lives.isFull();
    }
};

ExpeditionPage.prototype.getStartTime = function () {
    const locationMeta = cleverapps.meta.getLocationMeta(this.id);
    return locationMeta.getStartTime();
};

ExpeditionPage.prototype.getTimeLeft = function () {
    const locationMeta = cleverapps.meta.getLocationMeta(this.id);
    return locationMeta.getTimeLeft();
};

ExpeditionPage.prototype.updateState = function () {
    this.state = this.calcState();

    this.title = `TravelBook.title.${this.id}`;
    if (this.isUpcoming()) {
        this.title = "TravelBook.soon";
    }

    this.forceText = `TravelBookForce.${this.id}`;

    this.events = this.listEvents();

    if (this.events[0]) {
        this.message = typeof this.events[0].message === "function" ? this.events[0].message(this) : this.events[0].message;
        const events = cleverapps.dataLoader.load(DataLoader.TYPES.TRAVEL_BOOK_EVENTS + this.id) || {};
        events[this.events[0].type] = undefined;
        cleverapps.dataLoader.save(DataLoader.TYPES.TRAVEL_BOOK_EVENTS + this.id, events);
    } else {
        this.message = undefined;
    }

    if (this.isCompleted()) {
        this.setAttentionEvent(ExpeditionPage.EVENT_FINISH);
    }

    this.attention = !this.isCurrent() && this.events.find(function (event) {
        return event.type === this.attentionEvent;
    }, this);

    this.updateSideBar();
};

ExpeditionPage.prototype.resetEvents = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.TRAVEL_BOOK_EVENTS + this.id, {});
};

ExpeditionPage.prototype.setNew = function (isNew) {
    this.isNew = isNew;
};

ExpeditionPage.prototype.setAttentionEvent = function (attentionEvent) {
    if (this.attentionEvent === attentionEvent) {
        return;
    }

    this.attentionEvent = attentionEvent;

    cleverapps.dataLoader.save(DataLoader.TYPES.TRAVEL_BOOK_ATTENTION + this.id, attentionEvent);
};

ExpeditionPage.prototype.getIntroWindowLastShown = function () {
    return cleverapps.dataLoader.load(DataLoader.TYPES.INTRO_WINDOW_SHOWN + this.id) || 0;
};

ExpeditionPage.prototype.setIntroWindowShown = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.INTRO_WINDOW_SHOWN + this.id, Date.now());
};

ExpeditionPage.prototype.resetIntroWindowShown = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.INTRO_WINDOW_SHOWN + this.id, 0);
};

ExpeditionPage.prototype.planEvent = function (type, time) {
    const events = cleverapps.dataLoader.load(DataLoader.TYPES.TRAVEL_BOOK_EVENTS + this.id) || {};

    events[type] = {
        time
    };

    cleverapps.dataLoader.save(DataLoader.TYPES.TRAVEL_BOOK_EVENTS + this.id, events);
};

ExpeditionPage.prototype.listEvents = function () {
    if (!this.isActive()) {
        return [];
    }

    const events = cleverapps.dataLoader.load(DataLoader.TYPES.TRAVEL_BOOK_EVENTS + this.id) || {};

    return ExpeditionPage.EVENTS.filter(function (event) {
        const hasEventInStorage = Boolean(events[event.type] && events[event.type].time && events[event.type].time < Date.now());
        if (event.filter) {
            return event.filter(this, hasEventInStorage);
        }

        return hasEventInStorage;
    }, this);
};

ExpeditionPage.prototype.isPassed = function () {
    const locationMeta = cleverapps.meta.getLocationMeta(this.id);
    return locationMeta.isPassed();
};

ExpeditionPage.prototype.calcState = function () {
    if (this.isMain) {
        return ExpeditionPage.TYPE_ACTIVE;
    }

    if (cleverapps.meta.listActiveLocations().indexOf(this.id) !== -1) {
        return ExpeditionPage.TYPE_ACTIVE;
    }

    if (this.abTest) {
        const group = ABExperiments.Tests && cleverapps.abExperiments.getGroup(ABExperiments.Tests[this.abTest]);
        if (group !== "A") {
            return ExpeditionPage.TYPE_SKIP;
        }
    }

    if (this.isPermanent()) {
        return ExpeditionPage.TYPE_UPCOMING;
    }

    if (this.isPassed()) {
        return ExpeditionPage.TYPE_SKIP;
    }

    if (!cleverapps.user.checkAvailable(this.available)) {
        return ExpeditionPage.TYPE_SKIP;
    }

    const locationMeta = cleverapps.meta.getLocationMeta(this.id);
    if (locationMeta.getTimeToNextStart() < cleverapps.parseInterval("3 days")) {
        return ExpeditionPage.TYPE_UPCOMING;
    }

    return ExpeditionPage.TYPE_SKIP;
};

ExpeditionPage.prototype.isActive = function () {
    return this.state === ExpeditionPage.TYPE_ACTIVE;
};

ExpeditionPage.prototype.isUpcoming = function () {
    return this.state === ExpeditionPage.TYPE_UPCOMING;
};

ExpeditionPage.prototype.isPermanent = function () {
    return Boolean(this.permanent);
};

ExpeditionPage.prototype.isCompleted = function () {
    const locationMeta = cleverapps.meta.getLocationMeta(this.id);
    return locationMeta.isExpired();
};

ExpeditionPage.prototype.isCurrent = function () {
    return cleverapps.meta.selectedLocationId() === this.id;
};

ExpeditionPage.prototype.getButtonMsg = function () {
    if (this.isUpcoming()) {
        if (this.isPermanent() && this.levelsUntil() > 0) {
            return Messages.get("UnlockOnLevel", { level: Math.floor(this.available.level + 1) });
        }
        return Messages.get("Soon");
    }
    return Messages.get("Go");
};

ExpeditionPage.prototype.getTooltipMsg = function () {
    if (this.isPermanent() && this.levelsUntil() > 0) {
        return Messages.get("UnlockOnLevel", { level: Math.floor(this.available.level + 1) });
    }
    return Messages.get("TravelBook.soonTooltip");
};

ExpeditionPage.prototype.levelsUntil = function () {
    return Math.floor(this.available.level) - cleverapps.user.getLevel();
};

ExpeditionPage.prototype.updateSideBar = function () {
    const icon = cleverapps.sideBar.findExpeditionIcon(this.id);
    const isActive = !this.isMain && this.isActive() && cleverapps.meta.listActiveLocations().indexOf(this.id) !== -1;

    if (icon) {
        if (isActive) {
            cleverapps.sideBar.resetIcon(icon);
        } else {
            cleverapps.sideBar.removeTemporaryIcon(icon);
        }
    } else if (isActive) {
        cleverapps.sideBar.addTemporaryIcon(new ExpeditionIcon(this.id));
    }
};

ExpeditionPage.EVENT_START = "start";
ExpeditionPage.EVENT_GOALS_DONE = "done";
ExpeditionPage.EVENT_FINISH = "finish";
ExpeditionPage.EVENT_ENERGY = "energy";
ExpeditionPage.EVENT_KEYS = "keys";
ExpeditionPage.EVENT_BUILT = "built";

ExpeditionPage.EVENTS = [
    {
        type: ExpeditionPage.EVENT_START,
        message: {
            text: "TravelBook.message.welcome"
        },
        filter: function (page) {
            return page.isNew;
        }
    },
    {
        type: ExpeditionPage.EVENT_FINISH,
        message: function () {
            return {
                text: "TravelBook.message.finished",
                icon: bundles.travel_book.frames.icon_finish
            };
        },
        filter: function (page) {
            return page.isCompleted();
        }
    },
    {
        type: ExpeditionPage.EVENT_GOALS_DONE,
        message: {
            text: "TravelBook.message.done"
        },
        filter: function (page) {
            if (page.id === "adventure") {
                const config = AchievementsConfig.findByExpedition("adventure");
                return config && cleverapps.achievements && cleverapps.achievements.isGathered(config.id);
            }
        }
    },
    {
        type: ExpeditionPage.EVENT_BUILT,
        message: function () {
            return {
                text: "TravelBook.message.built",
                icon: bundles.travel_book.frames.icon_built
            };
        }
    },
    {
        type: ExpeditionPage.EVENT_KEYS,
        message: function (page) {
            return {
                icon: bundles.travel_book.frames[`icon_key_${page.id}`],
                text: `TravelBook.message.keys.${page.id}`
            };
        }
    },
    {
        type: ExpeditionPage.EVENT_ENERGY,
        message: function (page) {
            return {
                icon: page.isMain ? bundles.travel_book.frames.icon_energy_main : bundles.travel_book.frames.icon_energy_expedition,
                text: "TravelBook.message.energy"
            };
        },
        filter: function (page) {
            return page.livesWasFull;
        }
    }
];
